export * from './lib/shared-ui-assets.module';
